import { createFileRoute, Link } from "@tanstack/react-router";
import { Crown, FileText, Sparkles } from "lucide-react";
import { CONTRACT_TEMPLATES_META } from "@/lib/contract-templates";

export const Route = createFileRoute("/_authenticated/portal/admin/library")({
  component: AdminLibrary,
});

function AdminLibrary() {
  return (
    <section className="space-y-6">
      <header className="rounded-lg border border-emerald-300 bg-emerald-50 p-4">
        <div className="flex items-start gap-3">
          <Crown className="mt-0.5 h-5 w-5 text-emerald-700" />
          <div>
            <h2 className="font-display text-xl text-navy">Template library</h2>
            <p className="mt-1 text-sm text-emerald-900">
              Every template is now free for everyone. Use the public contracts
              page to personalise and download any document.
            </p>
          </div>
        </div>
      </header>

      <ul className="grid gap-3 sm:grid-cols-2">
        {CONTRACT_TEMPLATES_META.map((tpl) => (
          <li key={tpl.slug}>
            <Link
              to="/contracts/$slug"
              params={{ slug: tpl.slug }}
              className="flex h-full w-full flex-col rounded-lg border border-border bg-card p-4 hover:border-navy"
            >
              <div className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-navy" />
                <span className="text-sm font-medium text-navy">{tpl.title}</span>
              </div>
              <p className="mt-2 text-xs text-muted-foreground">{tpl.description}</p>
              <p className="mt-3 text-[11px] text-foreground/60">{tpl.category} · Free</p>
            </Link>
          </li>
        ))}
      </ul>

      <Link
        to="/cv-services"
        className="flex items-center justify-between rounded-lg border border-border bg-card p-4 hover:border-navy"
      >
        <div className="flex items-center gap-3">
          <Sparkles className="h-5 w-5 text-navy" />
          <div>
            <p className="text-sm font-medium text-navy">CV services</p>
            <p className="text-xs text-muted-foreground">Browse all CV templates — free.</p>
          </div>
        </div>
        <span className="text-xs text-navy underline">Open</span>
      </Link>
    </section>
  );
}
